import { requireAnySystemPermission, requireOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getActiveOrganizations } from '../mission/utils/getActiveOrganizations';
export function authorizeManageMission(userState, missionTypeId) {
    return (requireAnySystemPermission(userState, 'manage-missions') ||
        (!!missionTypeId && userState.authorizedMissionTypeIds.includes(missionTypeId)));
}
export function authorizeManageMissionByManageOrgPermission(userState, missionOrganizationSharingIds) {
    const activeOrganizationIds = getActiveOrganizations(userState);
    const userCanSeeSomeMissionsByType = userState.authorizedMissionTypeIds.length > 0;
    return (requireAnySystemPermission(userState, 'manage-missions') ||
        (requireAnySystemPermission(userState, 'manage-all-admin-missions') &&
            userCanSeeSomeMissionsByType &&
            missionOrganizationSharingIds.some((id) => activeOrganizationIds.includes(id) && requireOrgPermission(userState, id, 'manage-organization'))));
}
export function authorizeManageMissionClassifiers(userState) {
    return requireAnySystemPermission(userState, 'manage-mission-classifiers');
}
